import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MembersBulkImportTasksComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MembersBulkImportTasksPage" */ "@circle-react/components/SettingsApp/AsyncTasks"
    ),
);

export const MembersBulkImportTasksPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MembersBulkImportTasksComponent />
  </Suspense>
);
